// extracted by mini-css-extract-plugin
export default {"container":"index-module__rlfdO","blueWrapper":"index-module__Pq4i7"};